export const SANDBOX_ONBOARDING_URL = 'https://sandbox.onboarding.gigsafe.com'

export function isSandbox(): boolean {
  return process.env.REACT_APP_ONBOARDING_CLIENT_URL === SANDBOX_ONBOARDING_URL
}
